import React from 'react';
import SectionShell from '../SectionShell';
import useClickToArmVideo from '../../hooks/useClickToArmVideo';

/**
 * Full-bleed video slide: "VLOG Teil 1 — Hinter den Kulissen der
 * Schleiferei mit COO Michael Lang".
 *
 * Presenter flow (arm-on-second-click):
 *  • Slide enters viewport → video stays paused at time 0
 *  • 1st non-interactive click on the slide → video starts (click swallowed
 *    so the presentation does NOT advance)
 *  • 2nd click → normal advance to the next slide
 *  • Slide leaves viewport → video pauses + rewinds; arming resets
 */
const VIDEO_SRC = '/videos/vlog-schleiferei.mp4';

export default function SectionZertifiziertVideo() {
  const { videoRef, stageRef } = useClickToArmVideo('zertifiziert-video');

  return (
    <SectionShell
      id="zertifiziert-video"
      className="relative overflow-hidden"
      fullBleed
      centerContent
    >
      <div
        ref={stageRef}
        className="zert-video-stage"
        data-testid="zertifiziert-video-stage"
      >
        <div className="zert-video-frame">
          <video
            ref={videoRef}
            className="zert-video-el"
            playsInline
            controls
            preload="metadata"
            data-testid="zertifiziert-video"
            poster="/videos/vlog-poster.jpg"
          >
            <source src={VIDEO_SRC} type="video/mp4" />
          </video>
        </div>
      </div>
    </SectionShell>
  );
}
